import "./datatable.scss";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import {
  subjectColumns,
  subjectRows,
  fetchSubjectRows,
} from "../../datatablesource";
import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import { useSlug } from "../../SlugContext";
import { serverUrl } from "../../temp";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Loader from "../loader/Loader";

const SubjectDataTable = () => {
  const [data, setData] = useState(subjectRows);
  const [loading, setLoading] = useState(false);
  const { slugs } = useSlug();
  console.log("slug abbas check", slugs);
  useEffect(() => {
    const getData = async () => {
      setLoading(true);
      const rows = await fetchSubjectRows();
      console.log("jawad", rows);
      setLoading(false);
      setData(Array.from(rows.data));
    };
    getData();
  }, []);
  const handleDelete = (id) => {
    // Make a DELETE request to the Flask API endpoint
    fetch(`${serverUrl}/del_subject/${id}`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Failed to delete subject");
        }
        setData(data.filter((item) => item.id !== id));
        toast.success("Subject deleted successfully!");
      })
      .catch((error) => {
        console.error("Delete error:", error);
        toast.error("Failed to delete subject. Please try again.");
      });
  };
  // const listingLinkString = "Coursechapter-Listing";
  const viewLinkString = "Subject-Single";
  const editLinkString = "Subject-Edit";
  const newLinkString = "Subject-New";
  const actionColumn = [
    {
      field: "action",
      headerName: "Action",
      width: 200,
      renderCell: (params) => {
        return (
          <div className="cellAction">
            {slugs && slugs.includes(viewLinkString) && (
              <Link
                to={`/subject/${params.row.id}`}
                style={{ textDecoration: "none" }}
              >
                <div className="viewButton">View</div>
              </Link>
            )}
            {slugs && slugs.includes(editLinkString) && (
              <Link
                to={`/subject/update-subject/${params.row.id}`}
                style={{ textDecoration: "none" }}
              >
                <div className="editButton">Edit</div>
              </Link>
            )}
            <div
              className="deleteButton disabled"
              onClick={() => handleDelete(params.row.id)}
            >
              Delete
            </div>
          </div>
        );
      },
    },
  ];
  return (
    <div className="datatable">
      <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between w-full gap-3 pb-2 lg:pb-2">
        <div className="text-gray-700 text-2xl">Subjects</div>
        <div className="flex flex-col sm:flex-row gap-2 w-full lg:w-auto">
          {slugs && slugs.includes(newLinkString) && (
            <Link to="/subject/new" className="commonButton w-full sm:w-auto">
              Add New
            </Link>
          )}
        </div>
      </div>
      {loading ? (
        // <h1 style={{ textAlign: "center", paddingTop: "20%" }}>loading...</h1>
        <Loader fullScreen={false} />
      ) : (
        <DataGrid
          className="datagrid"
          rows={data}
          columns={subjectColumns.concat(actionColumn)}
          pageSize={9}
          rowsPerPageOptions={[9]}
          components={{
            Toolbar: GridToolbar, // Include the GridToolbar in the Toolbar slot
          }}
        />
      )}
      <ToastContainer position="top-right" autoClose={3000} />
    </div>
  );
};

export default SubjectDataTable;
